//* 화환 주문의 수령인 이름(deliveryDetail.receiverName) 존칭 처리 유틸
//*
//* 저장 형태가 두 가지다.
//*  - 현재: 주문 생성 시 "OOO 상주님"으로 저장 (체크아웃/전화주문/수령인 수정 모두 동일)
//*  - 구주문·직접입력: "OOO"처럼 접미사 없이 저장된 건도 남아 있다 (전체의 약 1%)
//*
//* 그래서 표시할 때 무조건 "님"/"상주님"을 덧붙이면 "OOO 상주님님" / "OOO 상주님 상주님"이 된다.
//* (실제로 계좌안내 문자에서 "받으실분: 김OO 상주님님"으로 나간 사고가 있었다)
//* 붙이는 쪽은 항상 아래 헬퍼를 거칠 것. 백엔드 알림 템플릿에도 같은 규칙 요청함
//* (docs/shop-order-receiver-name-honorific-spec.md)

//* 존칭을 떼고 순수 이름만 — 화면 표기·복사·상주 매칭용
export const bareReceiverName = (name?: string): string =>
  (name ?? '').replace(/\s*(상주)?님\s*$/, '').trim();

//* 존칭을 한 번만 붙인다. 이미 "…님"으로 끝나면 그대로 둔다(구주문만 접미사가 붙는다)
export const receiverNameWithHonorific = (name?: string): string => {
  const trimmed = (name ?? '').trim();
  if (!trimmed) return '';
  return /님$/.test(trimmed) ? trimmed : `${trimmed} 상주님`;
};

//* 입력값 정리 — "상주님님", "님 님"처럼 존칭이 겹쳐 들어온 경우만 하나로 접는다.
//* (접미사가 없는 이름에 임의로 붙이지는 않는다 — 데스크·법인 등 상주가 아닌 수령인 보존)
export const normalizeReceiverNameInput = (name?: string): string =>
  (name ?? '')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/(님)(\s*님)+$/, '$1');
